import getUserData from 'utils/user';
import { gfhAPI } from '../httpClient';

export interface IBaseUserInfo {
  userId: string;
  username: string;
  firstName: string;
  lastName: string;
  userLinks: any[];
  isOnboardingUser: boolean;
  inTrial: boolean;
  dayOfTrial: number;
  subscribed: boolean;
  trialEndDate: string;
  accountId: string;
  country: string;
}

export interface IBaseUserInfoResponse {
  success: boolean;
  errorCode: number;
  errorMessage: string;
  message: string;
  baseUserInfo: IBaseUserInfo | null;
}

const getBaseUserInfo = async (): Promise<IBaseUserInfoResponse> => {
  const ypaUserId = getUserData()?.ypaUserId;
  const { data } = await gfhAPI.post('/baseUserInfo', { userId: ypaUserId });
  return data;
};

export default getBaseUserInfo;
